import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import type { ChartOptions } from "chart.js";
import { Bar } from "react-chartjs-2";
import type { EpicBossFrequency } from "../../types/epicLeaderboard";
import { getEpicColor } from "../../utils/epicColors";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ROW_HEIGHT_PX = 26;
const AXIS_HEIGHT_PX = 44;

type Props = {
  epicName: string;
  bosses: EpicBossFrequency[];
};

// Horizontal bars: share of runs each boss showed up in.
const EpicBossChart = ({ epicName, bosses }: Props) => {
  const color = getEpicColor(epicName);

  const options: ChartOptions<"bar"> = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          color: "rgb(199, 238, 255)",
          callback: (value) => `${value}%`
        },
        grid: { color: "rgb(70, 130, 180)" }
      },
      y: {
        ticks: { color: "rgb(199, 238, 255)", autoSkip: false },
        grid: { display: false }
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const boss = bosses[ctx.dataIndex];
            return `${boss.runs.toLocaleString()} runs (${boss.pct}%)`;
          }
        }
      }
    }
  };

  return (
    <div
      className="epic-lb-boss-chart"
      style={{ height: bosses.length * ROW_HEIGHT_PX + AXIS_HEIGHT_PX }}
    >
      <Bar
        options={options}
        data={{
          labels: bosses.map((b) => b.name),
          datasets: [
            {
              label: "Share of runs",
              data: bosses.map((b) => b.pct),
              borderColor: color,
              backgroundColor: `${color}cc`
            }
          ]
        }}
      />
    </div>
  );
};

export default EpicBossChart;
